// removed by extract-text-webpack-plugin
module.exports = {"tag-list":"_1E7ZOqsy","tagList":"_1E7ZOqsy","tag":"_2zma7Xn1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TagList/TagList.pcss
// module id = 749
// module chunks = 0